import { UserDashboardWidgetItemModel } from 'shared/models';

export interface GroupItem {
    id: string;
    name: string;
    is_complex?: boolean;
}

export const getMonoGroupId = (
    storeId: number | string | null | undefined,
    items: UserDashboardWidgetItemModel[],
    groups: GroupItem[]
): string | null => {
    if (!storeId) return null;

    const complexIds = new Set(
        groups.filter(p => p.is_complex).map(p => p.id)
    );

    const itemGroups = items
        .filter(i => i.store_id === storeId)
        .map(i => i.group_id)
        .filter((g): g is string => g != null);

    const nonComplexGroups = itemGroups.filter(g => !complexIds.has(g));

    const set = new Set(nonComplexGroups);
    const uniqueGroups = Array.from(set);

    return uniqueGroups.length === 1 ? uniqueGroups[0] : null;
};

export const isMonoStore = (
    storeId: number | string | null | undefined,
    items: UserDashboardWidgetItemModel[],
    groups: GroupItem[]
): boolean => {
    return getMonoGroupId(storeId, items, groups) !== null;
};
